module.exports = __webpack_public_path__ + "images/emoji/heavy_multiplication_x.ecbd038dea041ed1e461.png";